import React from 'react';

import { Button, Tooltip } from '@mui/material';

/**
 * プロパティ
 */
export type Props = {
  /** ローディングが可能か */
  isEnableLoading: boolean,
  /** クリック */
  onClick: () => void,
};

const AdditionalLoading: React.FC<Props> = ({
  isEnableLoading,
  onClick,
}) => (
  <p style={{ textAlign: 'center' }}>
    <Tooltip title={isEnableLoading ? '追加で読み込みます' : 'すべて読み込みました'}>
      <span>
        <Button
          variant="contained"
          onClick={onClick}
          color="primary"
          disabled={!isEnableLoading}
        >
          追加読み込み
        </Button>
      </span>
    </Tooltip>
  </p>
);

export default AdditionalLoading;
